import clsx from "clsx";
import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";
import { variants } from "./variants";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  variant?: keyof typeof variants;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, variant = "DEFAULT", ...props }, ref) => {
    return (
      <button
        className={clsx(
          " bg-white flex justify-center items-center py-3 full-hd-bp:py-4 rounded-[1.11] max-lg:rounded-[4.3] font-bold text-[0.875em] full-hd-bp:text-[1em] leading-4",
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);
